import NeverKnowinglyUndersoldComponent from './NeverKnowinglyUndersoldComponent';

export default class SubmitButton extends NeverKnowinglyUndersoldComponent {
  constructor(button) {
    super(button);
  }

  render(state) {
    if (state.purchaseHistoryValid && state.retailerIsComparable) {
      this.rootElement.disabled = false;
    } else {
      this.rootElement.disabled = true;
      this.rootElement.classList.remove('button--loading');
      this.rootElement.classList.remove('u-button-loader');
    }
  }
}
